import { Component } from '@angular/core';
import {
  DropdownMenuComponent,
  MenuComponent,
  MenuItemComponent,
} from '@group24ag/flowkit';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-ui-dropdown-menu',
  imports: [DropdownMenuComponent, MenuComponent, MenuItemComponent],
  template: `
    <div>
      <h1 class="heading-title">Dropdown menu</h1>
      <ng-template #menuTemplateRef>
        <flk-menu>
          <div flkMenuItem>Item 1</div>
          <div flkMenuItem>Item 2</div>
          <div flkMenuItem>Item 3</div>
        </flk-menu>
      </ng-template>
      <div class="flex gap-4">
        <flk-dropdown-menu
          [icon]="['fas', 'plus']"
          [menuTemplate]="menuTemplateRef"
          >Add</flk-dropdown-menu
        >
        <flk-dropdown-menu
          [icon]="['fas', 'plus']"
          [menuTemplate]="menuTemplateRef"
          [appearance]="'secondary'"
          >Add</flk-dropdown-menu
        >
        <flk-dropdown-menu
          [icon]="['fas', 'plus']"
          [menuTemplate]="menuTemplateRef"
          [appearance]="'tertiary'"
          >Add</flk-dropdown-menu
        >
        <flk-dropdown-menu
          [icon]="['fas', 'plus']"
          [menuTemplate]="menuTemplateRef"
          [appearance]="'ghost'"
          >Add</flk-dropdown-menu
        >
      </div>
    </div>
  `,
})
export class UIDropdownMenuComponent {
  constructor(library: FaIconLibrary) {
    library.addIcons(faPlus);
  }
}
